import clamp from 'lodash.clamp';

import { MAX_SVG_TEXTURE_SIZE, MIN_SVG_TEXTURE_SIZE } from 'js/config/consts';

export const getClampedSvgSize = (dimension: number, scale: number, zoom: number) => {
  return clamp(dimension * scale * zoom, MIN_SVG_TEXTURE_SIZE, MAX_SVG_TEXTURE_SIZE);
};
